import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

export interface GridItem {
  label: string;
  path: string;
  editPath: string;
}

@Component({
  selector: 'app-navigation-grid',
  standalone: false,
  templateUrl: './navigation-grid.component.html',
  styleUrl: './navigation-grid.component.scss'
})
export class NavigationGridComponent {
  @Input() items: GridItem[] = [];
  @Input() showNavigation: boolean = true;
  @Input() showEdit: boolean = true;
  rows: { items: { label: string; navPath: string; disabled: boolean }[] }[] = [{ items: [] }, { items: [] }];
  columnWidth: string = '100%';
  itemMaxWidth: string = '100%';

  constructor(private router: Router) { }

  ngOnChanges(): void {
    this.updateGrid();
  }

  private updateGrid(): void {
    const n = this.items.length;
    if (n === 0) {
      this.rows = [{ items: [] }, { items: [] }];
      this.itemMaxWidth = '100%';
      return;
    }

    // Calculate max-width for each item: (available width - icon width - separator widths - margin) / n
    const iconWidthPx = 34; // 24px icon + 10px margin-right
    const separatorWidthPx = 20; // Approximate width of " > "
    const marginLeftPx = 32; // 2rem = 32px (margin-left: 2rem)
    const totalSeparatorWidthPx = (n - 1) * separatorWidthPx;
    const availableWidthPercentage = `calc((100% - ${iconWidthPx + totalSeparatorWidthPx + marginLeftPx}px) / ${n})`;
    this.itemMaxWidth = availableWidthPercentage;

    this.columnWidth = '100%';

    // Populate rows, disabling items with empty paths
    this.rows = [
      {
        items: this.showNavigation
          ? this.items.map(item => ({
            label: item.label,
            navPath: item.path,
            disabled: item.path === '',
          }))
          : [],
      },
      {
        items: this.showEdit
          ? this.items.map(item => ({
            label: item.label,
            navPath: item.editPath,
            disabled: item.editPath === '',
          }))
          : [],
      },
    ];
  }

  navigate(path: string): void {
    this.router.navigate([path]);
  }
}
